export default function Participe() {
  return (
    <>
      <section className="section parallax bg1" id="divider1">
        <div className="text-center">
          <hr className="divider" />
          <h1 className="h1">COMO PARTICIPAR DO L.R.M.C.?</h1>
          <hr className="divider" />
        </div>
      </section>
      <section className="section static-dark" id="participe">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h3 className="h3">COMO PARTICIPAR DO L.R.M.C.?</h3>
              <p>
                Estamos abertos à participação de todos, independente de idade,
                cilindrada e religião.
              </p>
              <p>
                Todos são bem-vindos a conhecer um pouco mais do Lord Riders
                Moto Clube, até quem não possui moto.
              </p>
              <p>
                Para iniciar sua caminhada e progressão para fazer parte do
                L.R.M.C. basta entrar em contato com algum membro e expressar o
                seu desejo em participar ou nos mandar uma mensagem nas redes
                sociais do Clube. Além disso, é importante participar dos
                Lighthouses; ser um voluntário no Pilotando para Vida; ser
                participativo; disposto a aprender a história e seguir os
                costumes e regras do Clube; e a dedicar tempo e servir a família
                Riders e suas atividades.
              </p>
              <p>
                Para dúvidas ou mais informações, entre em contato com a gente.
              </p>
              <a href="#contato" className="btn btn-primary">
                Entre em contato!
              </a>
            </div>
          </div>
        </div>
        <a href="#top-bar" className="back-top a-light">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-arrow-up-circle-fill"
            viewBox="0 0 16 16"
          >
            <path d="M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0zm-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z" />
          </svg>
        </a>
      </section>
    </>
  );
}
